import { Flex } from '@chakra-ui/react';
import { contentSx } from './styles';
import { ContextMenu, useContextMenu } from '../ChakraTableList';
import { PinnedSong } from './types';
import { PinnedSongItem } from './PinnedSongItem';

interface PinnedSongsListProps {
  data: PinnedSong[];
}

export const PinnedSongsList = ({ data }: PinnedSongsListProps) => {
  const contextMenuProps = useContextMenu();
  return (
    <Flex sx={contentSx}>
      <ContextMenu contextMenuProps={contextMenuProps} />
      {data.map((item) => (
        <PinnedSongItem
          key={item.guid}
          {...item}
          contextMenuProps={contextMenuProps}
        />
      ))}
    </Flex>
  );
};
